const ROOT_SHARED_ID = 'root-shared';
const ROOT_PERSONAL_ID = 'root-personal';
const ROOT_ORPHANED_ID = 'root-orphaned';

const ROOT_SHARED_VALUE = 'shared-root';
const ROOT_PERSONAL_VALUE = 'personal-root';

const buildFolderNode = (folder) => {
  const childFolders = (folder.children || []).map(buildFolderNode);
  const childProjects = (folder.projects || []).map((project) => ({
    type: 'project',
    id: project.id,
    name: project.name,
  }));

  return {
    type: 'folder',
    id: folder.id,
    name: folder.name,
    isPersonal: !!folder.isPersonal,
    children: [...childFolders, ...childProjects],
  };
};

export const buildSelectionTree = (folderTree = {}) => {
  const nodes = [];

  if (folderTree?.shared?.length) {
    nodes.push({
      type: 'folder',
      id: ROOT_SHARED_ID,
      name: 'Shared',
      children: folderTree.shared.map(buildFolderNode),
    });
  }

  if (folderTree?.personal?.length) {
    nodes.push({
      type: 'folder',
      id: ROOT_PERSONAL_ID,
      name: 'Personal',
      children: folderTree.personal.map(buildFolderNode),
    });
  }

  if (folderTree?.orphanedShared?.length) {
    nodes.push({
      type: 'folder',
      id: ROOT_ORPHANED_ID,
      name: 'No Folder',
      children: folderTree.orphanedShared.map((project) => ({
        type: 'project',
        id: project.id,
        name: project.name,
      })),
    });
  }

  return nodes;
};

export const getFolderDropdownOptions = (folderTree = {}, { includeRootOptions = false } = {}) => {
  const nodes = buildSelectionTree(folderTree);
  const options = [];

  const walk = (node, depth, rootId) => {
    if (node.type !== 'folder') {
      return;
    }

    const currentRootId = rootId || node.id;
    const isRootNode = node.id === ROOT_SHARED_ID || node.id === ROOT_PERSONAL_ID;

    if (isRootNode) {
      if (includeRootOptions) {
        options.push({
          value: node.id === ROOT_PERSONAL_ID ? ROOT_PERSONAL_VALUE : ROOT_SHARED_VALUE,
          label: node.name,
          depth,
          isRoot: true,
          isPersonal: node.id === ROOT_PERSONAL_ID,
        });
      }
    } else {
      options.push({
        value: node.id,
        label: node.name,
        depth,
        isRoot: false,
        isPersonal: currentRootId === ROOT_PERSONAL_ID,
      });
    }

    (node.children || []).forEach((child) => {
      if (child.type === 'folder') {
        walk(child, depth + 1, currentRootId);
      }
    });
  };

  nodes
    .filter((node) => node.id !== ROOT_ORPHANED_ID)
    .forEach((node) => walk(node, 0, node.id));

  return options;
};